import {all, call, debounce, put, select, takeEvery, takeLatest} from 'redux-saga/effects';
import {APP_BOOTED} from '../app/constants';
import {NOTIFICATIONS_NEW_ONE_CREATED, NOTIFICATIONS_TOGGLE_LIST} from './contants';
import app from '../../helpers/app';
import {toggleNotificationsList} from './actions';
import {IReduxRootState} from '../../@interfaces';
import {SettingsKeys} from '../../@interfaces/services/Settings/ISettings';
import {randomInteger} from '../../helpers/rand';
import {getMessagesQueryKey} from '../../components/_layouts/Default/components/content/notifications/Messages';
import {QueryKey} from '@tanstack/react-query';
import queryClient from '../../react-query-client';

function* bootWatcher() {
    yield takeLatest(APP_BOOTED, function* () {
        const displayed: boolean | null = yield call(() => {
            return app('settings').get(SettingsKeys.NOTIFICATIONS_DISPLAYED);
        });
        if (displayed == null) {
            return;
        }

        yield put(toggleNotificationsList(displayed));
    });
}

function* onNotificationsListToggleWatcher() {
    yield takeEvery(NOTIFICATIONS_TOGGLE_LIST, function* (action: any) {
        let displayed: boolean | null = action.payload.listDisplayed;
        if (displayed == null) {
            displayed = yield select((state: IReduxRootState) => state.notifications.listDisplayed);
        }

        yield call(() => {
            app('settings').set(SettingsKeys.NOTIFICATIONS_DISPLAYED, displayed);
        });
    });
}

function* newNotificationCreatedWatcher() {
    yield debounce(randomInteger(300, 1000), NOTIFICATIONS_NEW_ONE_CREATED, function* () {
        const displayed: boolean = yield select((state: IReduxRootState) => state.notifications.listDisplayed);
        const key: QueryKey = yield call(() => getMessagesQueryKey());
        if (displayed) {
            yield call(() => queryClient.refetchQueries(key, {exact: false}));
        } else {
            yield call(() => queryClient.invalidateQueries(key, {exact: false}));
        }
    });
}

export function* notificationsSaga() {
    yield all([
        bootWatcher(),
        onNotificationsListToggleWatcher(),
        newNotificationCreatedWatcher(),
    ]);
}
